export enum BloodTestingTag {    
    Cryo = 1,
    Serology = 2,
    Xm = 3
}